// USD-Format mit Sub-Cent-Auflösung.
// < $1.00: 4 Dezimalstellen (z.B. "$0.0123") — sub-Cent-Kosten sichtbar
// >= $1.00: 2 Dezimalstellen (z.B. "$12.45") — gewöhnliches USD-Format
// negative oder NaN: "—"
export function formatUsd(value: number | null | undefined): string {
  if (value == null || Number.isNaN(value) || value < 0) return "—";
  if (value === 0) return "$0.0000";
  const digits = value < 1 ? 4 : 2;
  return `$${value.toFixed(digits)}`;
}

// Threshold-Klassifikation für UI-Highlight.
// > $1.00: "alert" (rot)   — Outlier, prüfen
// > $0.10: "warn" (gelb)   — bemerkenswert, im Auge behalten
// <=$0.10: "ok"   (default) — normal
export function costThreshold(value: number): "alert" | "warn" | "ok" {
  if (value > 1) return "alert";
  if (value > 0.1) return "warn";
  return "ok";
}

// Tailwind-Klasse für Cost-Highlight nach Schwelle. Zentralisiert (#redesign Welle A):
// war 1:1 dupliziert in SessionsSection + TopCostAgentsCard (minimal divergent).
export function costClassName(value: number): string {
  const t = costThreshold(value);
  if (t === "alert") return "text-red font-semibold";
  if (t === "warn") return "text-yellow";
  return "text-text";
}
